module.exports = __webpack_public_path__ + "img/bg-scene-3.598109b9.png";